import { PdpModes } from './constants';
import { Entries, KeyOf } from './types';

export function entries<T>(obj: T): Entries<T> {
  return Object.entries(obj) as Entries<T>;
}

export function keys<T>(obj: T): KeyOf<T>[] {
  return Object.keys(obj) as KeyOf<T>[];
}

export function isDefined<T>(v: T | null | undefined): v is T {
  return v !== null && v !== undefined;
}

export function asserts<T, K extends T>(
  v: T,
  assert: (v: T) => v is K,
  message: string
): asserts v is K {
  if (assert(v)) return;
  throw new Error(message);
}

export function chuckArray<T>(items: T[], chunkSize: number): T[][] {
  const res: T[][] = [];
  for (let i = 0; i < items.length; i += chunkSize) {
    res.push(items.slice(i, i + chunkSize));
  }
  return res;
}

export function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function pdpModesConvert(mode: string | string[] | undefined): PdpModes {
  switch (mode) {
    case PdpModes.BID_STEPPER.toString(): {
      return PdpModes.BID_STEPPER;
    }
    case PdpModes.BUY_NOW_STEPPER.toString(): {
      return PdpModes.BUY_NOW_STEPPER;
    }
    case PdpModes.BUY_NOW_STEPPER_WITH_INFO.toString(): {
      return PdpModes.BUY_NOW_STEPPER_WITH_INFO;
    }
    case PdpModes.DESCRIPTION.toString(): {
      return PdpModes.DESCRIPTION;
    }
    case PdpModes.BID_LIST.toString(): {
      return PdpModes.BID_LIST;
    }
    case PdpModes.VISIT_BOOKING_CREATION.toString(): {
      return PdpModes.VISIT_BOOKING_CREATION;
    }
    case PdpModes.VISIT_BOOKING_EDITING.toString(): {
      return PdpModes.VISIT_BOOKING_EDITING;
    }
    default:
      return PdpModes.PDP;
  }
}
